import { Observable, Subscription, timer } from 'rxjs';

import { debug } from './debug';
import { VirtualTargetDataCom } from './virtual-target';
import { TapServerError } from './tap-server-error';

export class DataLogEngine {
  /**
   * Single packets
   */
  packets: Uint8Array[] = [];

  private period = 5000;
  private _timer: Observable<number>;
  private _timerSubscription?: Subscription;

  get running() {
    return this._timerSubscription !== undefined;
  }

  constructor(private target: VirtualTargetDataCom) {
    this._timer = timer(0, this.period);
  }

  dequeue(): Uint8Array {
    if (this.packets.length === 0) {
      throw TapServerError.notAvailable();
    }
    return this.packets.splice(0, 1)[0];
  }

  flush() {
    this.packets = [];
  }

  start() {
    if (this._timerSubscription) {
      return;
    }
    this._timerSubscription = this._timer.subscribe(() => {
      try {
        for (const bundle of this.target.configExplorer.bundles) {
          if ((bundle.dataLog?.period || 0) > 0 && this.target.isConnected) {
            debug(`Datalog acquisition for bundle: ${bundle.id}`);
            const bundleValue = this.target.getBundleValues(bundle.id);
            this.packets.push(bundleValue);
          }
        }
      } catch (err) {
        debug(`Datalog acquisition error`, err);
      }
    });
  }

  stop() {
    this._timerSubscription?.unsubscribe();
    this._timerSubscription = undefined;
  }
}
